<template>
  <b-container fluid>
    <b-row class="mx-auto">
      <Practicienne
        v-for="practicienne in practiciennes"
        :key="practicienne.firstname"
        :firstname="practicienne.firstname"
        :surname="practicienne.surname"
        :formation="practicienne.formation"
        :picture="practicienne.picture"
        :skills="practicienne.skills"
        :location="practicienne.location"
        :text="practicienne.text"
        :link="practicienne.link"
        >{{ practicienne.text }}</Practicienne
      >
    </b-row>
  </b-container>
</template>

<script>
import Practicienne from "../components/Practicienne";

export default {
  data() {
    return {
      practiciennes: [
        {
          picture: "image36.jpg",
          firstname: "Agnès",
          surname: "Beille",
          skills:
            "Je suis les personnes présentant tout type de handicap : moteur, polyhandicap, troubles neurodéveloppementaux, troubles spécifiques des apprentissages… Je travaille en lien avec les différents intervenants de chaque patient.",
          formation:
            "Certificat de capacité d’Orthoptiste, faculté de Montpellier, DU Neuro-Ophtalmologie, DU Neuropsychopathologie des apprentissages scolaires, Formation PECS/ABA.",
          location: "St Martin d'Hères",
          link: "https://www.keldoc.com/orthoptiste/st-martin-d-heres-38400/agnes-beille#cabinet-13615",
          text:
            "J’effectue essentiellement des rééducations neurovisuelles enfants et adultes.",
        },
        {
		picture: "image34.jpg",
        firstname: "Lisa",
        surname: "Bertrand",
        link: "https://www.keldoc.com/orthoptiste/st-martin-d-heres-38400/lisa-bertrand#cabinet-13615",
        skills: "La prise en charge de l'insuffisance de convergence chez les enfants et adultes.",
        formation: "Certificat de capacité d'orthoptiste, diplômée de l'école de Lyon",
        location: "St Martin d'Hères",
        text: "J'effectue les rééducations des déséquilibres de la vision binoculaire et les contrôles de correction optique. Je prend également en charge les troubles d'apprentissages, strabismes, amblyopies et paralysies oculomotrices." 
		},
        {
          picture: "image39.jpg",
          firstname: "Fantine",
          surname: "Cave",
          formation:
            "Certificat de capacité d'orthoptiste, diplômée de l'école de Lyon",
          location: "St Martin d'Hères",
          link:
            "https://www.keldoc.com/orthoptiste/st-martin-d-heres-38400/fantine-cave#cabinet-13615",
          skills:
            "J'effectue les rééducations des déséquilibres de la vision binoculaire, les contrôles d'amblyopie, de corrections optiques. Je prends également en charge les troubles d'apprentissages, les strabismes et les paralysies oculomotrices.",
          text:
            "Je vais à domicile pour des rééducation basse vision. La prise en charge des troubles de l'apprentissages chez les enfants et l'insuffisance de convergence chez les enfants et adultes.",
        },
        {
          picture: "image40.jpg",
          firstname: "Isabelle",
          surname: "Cheymol",
          formation:
            "Certificat de capacité d’orthoptiste, faculté de Clermont Ferrand, DU neuropsychologie des apprentissages scolaires, formation neurovision et TND, formation sur les troubles de l’équilibre et vestibulaires (vertiges).",
          location: "St Martin d'Hères / Vif",
          link:
            "https://www.keldoc.com/orthoptiste/st-martin-d-heres-38400/isabelle-cheymol#cabinet-13615",
          skills:
            "Les strabismes, les prises en charges des patients polyhandicapés et autistes,  La rééducation des troubles vestibulaires (vertiges). Je réalise également les examens de dépistage de la rétinopathie diabétique. Prise en charge des patients sur Vif",
          text:
            "Je réalise tout type de prise en charge : dépistage visuel, strabisme, amblyopie, paralysie oculomotrice, suivi dans le cadre de troubles d’apprentissages, neurovision enfant et adulte, rééducation des troubles de l’équilibre et vestibulaires (vertiges). Je travaille en lien avec les différents intervenants de chaque patient.",
        },
        {
          picture: "image38.jpg",
          firstname: "Eva",
          surname: "Riché",
          skills: "Rééducation de la vision binoculaire et de l’accommodation, des troubles neurovisuels de l’enfant et de l’adulte, des vertiges. Suivi des paralysies oculomotrices, strabisme, amblyopie, dépistage visuel, adaptation de prismes et renouvellement de lunettes.",
          link:
            "https://www.keldoc.com/orthoptiste/st-martin-d-heres-38400/juliette-wemelle#cabinet-13615",
          formation:
            "Certificat de capacité d'orthoptiste, diplômée de l'école de Lyon, titulaire d’un Master 1 Santé et d’un Master 2 Innovations Technologiques pour de la recherche en neurosciences (Université Claude Bernard Lyon 1), ainsi que d’un DU de Neuro-ophtalmologie",
          location: "St Martin d'Hères et activité hospitalière au CHUGA en consultation spécialisée de neuro-ophtalmologie",
          text:
            "Expertise dans la prise en charge des troubles neurovisuels acquis (AVC, traumatismes crâniens, maladies neurologiques, suites chirurgicales…), bilans accommodatifs, adaptation et renouvellement des corrections optiques, accompagnement des patients vertigineux.",
        }
      ],
    };
  },
  components: {
    Practicienne,
  },
};
</script>

<style scoped>
img {
  margin-top: 80px;
  margin-bottom: 10px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  width: 100%;
}
</style>
